<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <!-- wrapper(s) -->
  <div class="wrapper" v-if="showDiv === 'main'">
    <Header class="header" :val="headerTitle"></Header>
    <div class="container">
      <!-- content(s) -->
      <div id="content">
        <div class="visual faq">
          <em class="tit">FAQ를 확인해보세요!</em>
          <p class="desc">
            AS방문없이 스스로 해결이 가능해요.
            <br />
            신청 전 확인해 보세요.
          </p>
          <div class="btnArea">
            <a class="btn_l s round" @click="$router.push({ name: 'customerCenterFaq', params: { mainType: '6', subType: '15' } })">FAQ 바로가기</a>
          </div>
        </div>
        <section class="hr pt25 mb25">
          <div class="btnArea mt0">
            <button type="button" class="btn_s m" @click="btnShowAsApplyDetail()">AS신청</button>
          </div>
        </section>
        <section class="hr">
          <div class="titArea">
            <h2 class="titH4">
              AS신청현황
              <span class="normal" v-if="serviceAuthAsList.length > 0">({{ serviceAuthAsList.length }})</span>
            </h2>
          </div>
          <ul class="accoList req" v-if="serviceAuthAsList.length > 0">
            <li v-for="(serviceAuthAs, index) in serviceAuthAsList" :key="index">
              <div class="accoHead">
                <ul class="infoList req">
                  <li class="info">
                    <span
                      class="item"
                      :class="{
                        pointC1: serviceAuthAs.progress == '처리중',
                        pointC4: serviceAuthAs.progress == '접수 완료' || serviceAuthAs.progress == '접수 취소',
                      }"
                    >
                      {{ serviceAuthAs.progress }}
                    </span>
                    <span class="val" v-if="serviceAuthAs.accepted">
                      <button type="button" class="btn_s s round" @click="applyCancel(serviceAuthAs.orderId, serviceAuthAs.receiptId)">
                        신청취소
                      </button>
                    </span>
                    <span class="val" v-else>
                      <button type="button" class="btn_s s round" disabled="disabled">신청취소</button>
                    </span>
                  </li>
                  <li>
                    <span class="item">신청상품</span>
                    <span class="val pointC7">{{ serviceAuthAs.productName }}</span>
                  </li>
                  <li>
                    <span class="item">주문번호</span>
                    <span class="val">{{ serviceAuthAs.orderId }}</span>
                  </li>
                  <li>
                    <span class="item">접수일</span>
                    <span class="val">{{ serviceAuthAs.receiptDate }}</span>
                  </li>
                  <li v-if="serviceAuthAs.progress != '처리완료'">
                    <span class="item">방문희망일</span>
                    <span class="val">
                      <datepicker
                        v-model="visitHopeDate[index]"
                        :disabled="!serviceAuthAs.wishModifiable"
                        :format="format"
                        :input-class="inputClass"
                        :language="lang"
                        v-bind:disabled-dates="selectVisitHopeDisalbledDate"
                      ></datepicker>
                      <!--<datepicker v-model="visitHopeDate[0]" :value="visitHopeDate[0]" :format="format" :input-class="inputClass" :language="lang" @selected="selectVisitHopeDate(0)"></datepicker>-->
                      <button
                        type="button"
                        class="links pointC1 as"
                        v-show="serviceAuthAs.wishModifiable"
                        @click="modifyVisitHopeDate(index, serviceAuthAs.orderId, serviceAuthAs.receiptId)"
                      >
                        변경
                      </button>
                    </span>
                  </li>
                </ul>
              </div>
              <div class="accoBody">
                <ul class="infoList req">
                  <li v-if="serviceAuthAs.progress == '처리완료'">
                    <span class="item">처리일</span>
                    <span class="val">{{ serviceAuthAs.completeDate }}</span>
                  </li>
                  <li>
                    <span class="item">접수유형</span>
                    <span class="val">{{ serviceAuthAs.receiptType }}</span>
                  </li>
                  <!--<li>
                    <span class="item">접수내용</span>
                    <span class="val">{{ serviceAuthAs.receiptContents }}</span>
                  </li>-->
                  <li>
                    <span class="item">주소</span>
                    <span class="val">{{ serviceAuthAs.address }}</span>
                  </li>
                  <li>
                    <span class="item">사진</span>
                    <span class="val" v-if="serviceAuthAs.hasPhotos">
                      <a href="javascript:void(0);" class="links pointC1" @click="photoZoom(serviceAuthAs.fileMngId)">Y</a>
                    </span>
                    <span class="val" v-else>N</span>
                  </li>
                </ul>
              </div>
              <button type="button" class="btnIco_acco accoBtn"><span>상세보기</span></button>
            </li>
          </ul>
          <div class="resultMsg txtOnly" v-else>
            <p class="copy">신청 내역이 없습니다.</p>
          </div>
        </section>

        <CommonBanner></CommonBanner>
      </div>
      <!-- content(e) -->
      <QuickMenu></QuickMenu>
    </div>
    <!-- container(e) -->
    <footer class="footer"></footer>

    <MessagePop v-if="messagePop" @close="close">
      <p v-html="msg"></p>
    </MessagePop>
  </div>
  <!-- wrapper(e) -->

  <!-- 사진 zoom popup (s) -->
  <div class="popWrap nowOpen" v-else-if="showDiv === 'asPhotosZoom'">
    <div class="popup">
      <div class="popContain">
        <div class="popCont full">
          <div class="popHead">
            <h1 class="titH1">확대보기</h1>
          </div>
          <div class="popBody photoView full">
            <div class="popInner">
              <!-- 본문 (s) -->
              <div class="zoomImg" style="text-align: center">
                <img
                  v-for="(photo, index) in photoList"
                  :key="index"
                  :src="`data:image/${photo.fileTpMCntn === 'jpg' ? 'jpeg' : photo.fileTpMCntn};base64,${photo.file}`"
                  style="width: 90%; padding-top: 10px"
                />
              </div>
              <!-- 본문 (e) -->
            </div>
          </div>

          <button type="button" class="btnIco_close" @click="showDiv = 'main'"><span>팝업 닫기</span></button>
        </div>
      </div>
    </div>
    <ProgressBar ref="progress"></ProgressBar>
  </div>
  <!-- 사진 zoom popup (e) -->

  <!-- as 신청 popup (s) -->
  <div class="popWrap nowOpen" v-else-if="showDiv === 'asApplyPop'">
    <div class="popup">
      <div class="popContain">
        <div class="popCont full hasBtn">
          <div class="popHead">
            <h1 class="titH1">AS신청</h1>
          </div>
          <div class="popBody">
            <div class="popInner">
              <!-- 본문 (s) -->
              <section>
                <ul class="txtList_square">
                  <li>렌탈기간내 AS는 무상이나 고객님 과실일 경우 유상청구됩니다.</li>
                  <li>
                    <span class="pointC1">선택한 방문일자와 실제 방문일자는 상이할 수 있습니다.</span>
                    자세한일정은 기사님과 협의해 주세요.
                  </li>
                </ul>
                <div class="formArea">
                  <span class="label">
                    상품선택
                    <span class="required"><span class="blind">필수</span></span>
                    <a @click="btnShowWelFoodDetail" class="btn_s s btnAsPop" v-if="showBtnShowWelFoodDetail" style="display: none">AS비용안내</a>
                  </span>
                  <select class="ipt" title="상품선택 선택" v-model="product" @change="changeProduct">
                    <option
                      disabled="disabled"
                      selected="selected"
                      v-bind:value="{ pb: false, orderId: '', supportAS: false, vendorName: '', serviceCenterTel: '', registered: false }"
                    >
                      선택해주세요
                    </option>
                    <option
                      v-for="(serviceAuthAsProduct, key) in serviceAuthAsProductsList"
                      v-bind:value="{
                        pb: serviceAuthAsProduct.pb,
                        orderId: serviceAuthAsProduct.orderId,
                        supportAS: serviceAuthAsProduct.supportAS,
                        vendorName: serviceAuthAsProduct.vendorName,
                        serviceCenterTel: serviceAuthAsProduct.serviceCenterTel,
                        registered: serviceAuthAsProduct.registered,
                        godsCrtnCd: serviceAuthAsProduct.godsCrtnCd,
                      }"
                      v-bind:key="key"
                    >
                      {{ serviceAuthAsProduct.orderId }} / {{ serviceAuthAsProduct.productName }}
                    </option>
                  </select>

                  <span class="label">
                    접수유형
                    <span class="required"><span class="blind">필수</span></span>
                  </span>
                  <select class="ipt" title="접수유형 선택" v-model="serviceAsType" id="serviceAsType">
                    <option value="" disabled="disabled" selected="selected">대분류</option>
                    <option v-for="(serviceAsType, key) in serviceAsTypeList" :value="serviceAsType.codeList[0].code" v-bind:key="key">
                      {{ serviceAsType.codeList[0].codeName }}
                    </option>
                  </select>

                  <span class="label">접수내용</span>
                  <textarea
                    class="ipt"
                    title="접수내용상세 입력"
                    placeholder="상세 AS요청 내용을 입력해주세요 (최대 100자 이내)"
                    v-model="asText"
                  ></textarea>
                  <!-- <button type="button" class="btn_s m">AS 비용안내</button> // 상품을 웰릭스 음식물처리기로 선택했을 경우에만 노출 -->

                  <span class="label">이름</span>
                  <input type="text" id="ipt1_1" class="ipt" title="이름" :value="userInfo.userName" readonly="readonly" />

                  <span class="label">연락처</span>
                  <input type="tel" id="phone_2" class="ipt" title="연락처" v-model="userInfoMobile" readonly="readonly" />

                  <span class="label">
                    방문희망일
                    <span class="required"><span class="blind">필수</span></span>
                  </span>
                  <!--<input type="text" id="ipt2_3" class="ipt date" title="방문요청일 선택" value="2017-04-20" />-->

                  <datepicker
                    :value="addVisitHopeDate"
                    :format="format"
                    :input-class="inputClass"
                    :language="lang"
                    v-bind:disabled-dates="addVisitHopeDisalbledDate"
                    v-model="addVisitHopeDate"
                    @closed="goScroll"
                  ></datepicker>

                  <!--
                  <span class="label">방문요청주소</span>
                  <div class="setAddr">
                    <input
                      type="tel"
                      id="addr_1"
                      class="ipt"
                      title="설치 주소 입력 (우편번호)"
                      placeholder="우편번호"
                      value=""
                      readonly="readonly"
                      v-model="addrPost"
                    />
                    <button type="button" class="btn_g m" @click="addrPopupOpen">
                      우편번호찾기
                    </button>
                  </div>
                  <input
                    type="text"
                    id="addr_2"
                    class="ipt"
                    placeholder="기본주소"
                    title="설치 주소 입력 (기본주소)"
                    value=""
                    readonly="readonly"
                    v-model="addrRoad"
                  />
                  <input type="text" id="addr_3" class="ipt" placeholder="상세주소" title="설치 주소 입력 (상세주소)" v-model="addrRemark" />
                  -->

                  <div class="btnArea" v-if="files.length < 2">
                    <button type="button" class="btn_s addPic" @click="clickImgAdd" id="focusId">
                      <span class="ico"><img src="@/../static/img/mw/common/ico_picture.png" /></span>
                      사진 첨부하기
                    </button>
                    <input type="file" id="file" style="display: none" @change="selectImg($event)" />
                  </div>

                  <ul class="thumList div_2 al">
                    <li v-for="(file, fileIndex) in files" :key="fileIndex">
                      <div class="block">
                        <img :src="imgPreview(file)" style="width: 100%; height: 100%" />
                        <button type="button" class="delBtn" @click="deleteImg(fileIndex)"><span class="blind">선택된 사진 삭제</span></button>
                      </div>
                    </li>
                  </ul>

                  <ul class="txtList_star txtXS mt15">
                    <li>사진은 최대 2장까지 업로드 가능합니다.</li>
                    <li>파일 용량은 20MB 이하로 업로드 가능합니다.</li>
                  </ul>
                </div>
              </section>
              <!-- 본문 (e) -->
            </div>
          </div>

          <div class="btnArea sticky">
            <button type="button" class="btn_p" @click="goAsComplete" :disabled="regButtonShow">접수완료</button>
          </div>

          <button type="button" class="btnIco_close" @click="showDiv = 'main'"><span>팝업 닫기</span></button>
        </div>
      </div>
    </div>

    <FindAddr v-if="findAddr" @callback="selectAddr" @close="close"></FindAddr>
    <MessagePop v-if="messagePop" @close="messagePop = false">
      <p v-html="msg"></p>
      <template v-slot:bottomButtom v-if="this.messageType == 'asComplete'">
        <button type="button" class="btn_p" @click="asApplyPopClose">확인</button>
      </template>
      <template v-slot:bottomButtom v-else-if="this.messageType == 'asNoPb'">
        <button type="button" class="btn_p" @click="asApplyPopClose">확인</button>
      </template>

      <template v-slot:closeButton v-if="this.messageType == 'asNoPb'">
        <button type="button" class="btnIco_close" @click="asApplyPopClose">
          <span>팝업 닫기</span>
        </button>
      </template>
    </MessagePop>

    <ProgressBar ref="progress"></ProgressBar>
  </div>
  <!-- popup (e) -->

  <!-- as 비용안내 (웰릭스음식물처리기 선택시) popup (s) -->
  <div class="popWrap nowOpen" v-else-if="showDiv === 'welFoodPop'">
    <div class="popup">
      <div class="popContain">
        <div class="popCont full">
          <div class="popHead">
            <h1 class="titH1">음식물처리기 AS비용</h1>
          </div>
          <div class="popBody">
            <div class="popInner">
              <section>
                <table class="tableX txtXS">
                  <caption>AS구분, 항목, 금액, 비고에 대한 내용입니다.</caption>
                  <colgroup>
                    <col style="width: 22%" />
                    <col style="width: 22%" />
                    <col style="width: 18%" />
                    <col style="width: auto" />
                  </colgroup>
                  <thead>
                    <tr>
                      <th>구분</th>
                      <th>항목</th>
                      <th>금액(원)</th>
                      <th>비고</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td rowspan="8">부품교체(사용)</td>
                      <td>편심(구형)</td>
                      <td class="ar">42,000</td>
                      <td>* DK-f1601 모델만 해당</td>
                    </tr>
                    <tr>
                      <td>편심(신형)</td>
                      <td class="ar">42,000</td>
                      <td>* DK-W2020 모델만 해당</td>
                    </tr>
                    <tr>
                      <td>PCB(구형)</td>
                      <td class="ar">50,000</td>
                      <td>* DK-f1601 모델만 해당</td>
                    </tr>
                    <tr>
                      <td>PCB(신형)</td>
                      <td class="ar">50,000</td>
                      <td>* DK-W2020 모델만 해당</td>
                    </tr>
                    <tr>
                      <td>EMI필터(구형)</td>
                      <td class="ar">26,000</td>
                      <td>* DK-f1601 모델만 해당</td>
                    </tr>
                    <tr>
                      <td>EMI필터(신형)</td>
                      <td class="ar">26,000</td>
                      <td>* DK-W2020 모델만 해당</td>
                    </tr>
                    <tr>
                      <td>접지콘센트</td>
                      <td class="ar">40,000</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>발판스위치</td>
                      <td class="ar">10,000</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td rowspan="3">제품교체</td>
                      <td>디스포저</td>
                      <td class="ar">200,000</td>
                      <td>* 디스포저: 1차처리기</td>
                    </tr>
                    <tr>
                      <td>교반기</td>
                      <td class="ar">200,000</td>
                      <td>* 교반기: 2차처리기</td>
                    </tr>
                    <tr>
                      <td>전체</td>
                      <td class="ar">400,000</td>
                      <td>* 1차 + 2차처리기</td>
                    </tr>
                    <tr>
                      <td rowspan="5">작업용역비</td>
                      <td>출장비</td>
                      <td class="ar">30,000</td>
                      <td>* 고객님 과실일 경우</td>
                    </tr>
                    <tr>
                      <td>이사전철거</td>
                      <td class="ar">33,000</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>이사후재설치</td>
                      <td class="ar">55,000</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>싱크대타공</td>
                      <td class="ar">55,000</td>
                      <td>* 특수설치비</td>
                    </tr>
                    <tr>
                      <td>외부전기선연결</td>
                      <td class="ar">25,000</td>
                      <td>* 특수설치비</td>
                    </tr>

                    <tr>
                      <td rowspan="3">소모품</td>
                      <td>미생물</td>
                      <td class="ar">33,000</td>
                      <td>* 1BOX</td>
                    </tr>
                    <tr>
                      <td>꽃거름망</td>
                      <td class="ar">3,000</td>
                      <td>* 1EA</td>
                    </tr>
                    <tr>
                      <td>누름봉</td>
                      <td class="ar">3,000</td>
                      <td>* 1EA</td>
                    </tr>
                  </tbody>
                </table>
                <ul class="txtList_disc txtXS">
                  <li>렌탈기간내 제품불량으로 인한 AS는 무상이나, 고객님 과실로 인한 AS발생시 비용은 유상입니다.</li>
                  <li>본 단가표는 "웰릭스 음식물처리기"에만 해당되는 내용입니다.</li>
                </ul>
              </section>
            </div>
          </div>

          <button type="button" class="btnIco_close" @click="btnShowAsApplyDetail"><span>팝업 닫기</span></button>
        </div>
      </div>
    </div>
  </div>
  <!-- popup (e) -->
</template>

<script>
import * as customjs from '@/../static/js/m.front.js';
import ApiService from '@/common/api.service';
import JwtService from '@/common/jwt.service';
import CommonBanner from '@/components/banner/CommonBanner';
import FindAddr from '@/components/comm/FindAddr';
import MessagePop from '@/components/popup/MessagePop';
import QuickMenu from '@/views/app/comm/QuickMenu';
import Datepicker from 'vuejs-datepicker';
import { ko } from 'vuejs-datepicker/dist/locale';
import moment from 'moment';
import { isEmpty } from '@/common/common.function';
import { SERVICE_COMM_ERROR } from '@/store/message.type.js';
import ProgressBar from '@/views/app/comm/ProgressBar';
import $ from 'jquery';

export default {
  name: 'asInfo',
  data() {
    return {
      headerTitle: 'AS신청',
      userInfo: JwtService.getUserInfo(),
      showDiv: 'main',
      msg: null,
      findAddr: false,
      messagePop: false,
      messageType: '',

      serviceAuthAsList: [],
      serviceAuthAsProductsList: [],
      product: { pb: false, orderId: '', supportAS: false, vendorName: '', serviceCenterTel: '', registered: false, godsCrtnCd: '' },
      serviceAsTypeList: [],
      serviceAsTypePbList: [], // TODO 파기
      serviceAsTypeNonpbList: [], // TODO 파기
      serviceAsType: '',
      addVisitHopeDate: '',
      asText: '',
      showBtnShowWelFoodDetail: false,
      files: [],

      userInfoMobile: '',

      addrCode: '',
      addrPost: '',
      addrRoad: '',
      addrJibun: '',
      addrRemark: '',
      nnmb: '',
      zip: '',
      nadr1: '',
      adr1: '',

      visitHopeDate: [], // 방문 희망일
      visitHopeDateDisabled: [], // 방문 희망일 disabled
      format: 'yyyy - MM - dd',
      inputClass: 'ipt date notDel uiAct w75',
      //calendarClass: 'ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all',
      lang: ko,
      flag: true,
      selectVisitHopeDisalbledDate: {
        to: this.calDay(),
        days: [6, 0],
      },
      addVisitHopeDisalbledDate: {
        to: this.calDay(),
        days: [6, 0],
      },
      photoList: [],

      regButtonShow: true,
      fileAuth: String,
    };
  },
  components: {
    CommonBanner,
    QuickMenu,
    FindAddr,
    MessagePop,
    Datepicker,
    ProgressBar,
  },
  watch: {
    showDiv() {
      if (this.showDiv == 'asApplyPop') {
        this.serviceAuthAsProductsList = [];
        this.product = { pb: false, orderId: '', supportAS: false, vendorName: '', serviceCenterTel: '', registered: false, godsCrtnCd: '' };
        this.serviceAsTypeList = [];
        this.serviceAsTypePbList = []; // TODO 파기
        this.serviceAsTypeNonpbList = []; // TODO 파기
        this.serviceAsType = '';
        this.addVisitHopeDate = '';
        this.asText = '';
        this.files = [];
        this.addrCode = '';
        this.addrPost = '';
        this.addrRoad = '';
        this.addrJibun = '';
        this.addrRemark = '';
        this.nnmb = '';
        this.zip = '';
        this.nadr1 = '';
        this.adr1 = '';

        this.selectlServiceAuthAsProducts();
        this.addVisitHopeDefaultDate();
      }
    },
    product() {
      this.checkInput();
    },
    serviceAsType() {
      this.checkInput();
    },
    addVisitHopeDate() {
      this.checkInput();
    },
    fileAuth() {
      if (this.fileAuth == 'false') {
        this.msg = `아이폰 설정 → welrixrental 앱 → <br/>사진, 카메라 권한을 허용해주세요.`;
        this.messagePop = true;
      }
    },
  },
  created() {
    window.getAppVersion();
  },
  mounted() {
    if (this.userInfo.mobile.length === 11) {
      this.userInfoMobile =
        this.userInfo.mobile.substring(0, 3) + '-' + this.userInfo.mobile.substring(3, 7) + '-' + this.userInfo.mobile.substring(7, 11);
    } else if (this.userInfo.mobile.length === 10) {
      this.userInfoMobile =
        this.userInfo.mobile.substring(0, 3) + '-' + this.userInfo.mobile.substring(3, 6) + '-' + this.userInfo.mobile.substring(6, 10);
    }

    this.selectServiceAuthAs();
    this.selectlServiceAuthAsProducts();
    this.addVisitHopeDefaultDate();
  },
  updated() {
    customjs.accoInit();
    customjs.iptInit();
  },
  methods: {
    selectServiceAuthAs() {
      ApiService.service('GET', '/service/auth/as')
        .then(({ data }) => {
          console.log(data);
          if (data.result != null) {
            this.serviceAuthAsList = data.result;
          }

          for (let i = 0; i < this.serviceAuthAsList.length; i++) {
            this.visitHopeDate[i] = this.serviceAuthAsList[i].wishDate;

            let today = new Date();
            today.setDate(today.getDate() + 1);

            if (new Number(moment(today).format('yyyyMMDD')) < new Number(this.serviceAuthAsList[i].wishDate.replace('-', '').replace('-', ''))) {
              this.visitHopeDateDisabled[i] = false;
            } else {
              this.visitHopeDateDisabled[i] = true;
            }
          }
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    selectlServiceAuthAsProducts() {
      ApiService.service('GET', '/service/auth/as/products')
        .then(({ data }) => {
          if (!isEmpty(data.result)) {
            this.serviceAuthAsProductsList = data.result.map((item) => {
              return {
                pb: item.productName === '(웰릭스) 클린 음처기_건조형_포레' ? false : item.pb,
                orderId: item.orderId,
                supportAS: item.productName === '(웰릭스) 클린 음처기_건조형_포레' ? false : item.supportAS,
                vendorName: item.vendorName,
                serviceCenterTel: item.serviceCenterTel,
                registered: item.registered,
                godsCrtnCd: item.godsCrtnCd,
                productName: item.productName,
              };
            });
          }
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    btnShowAsApplyDetail() {
      this.showDiv = 'asApplyPop';
      setTimeout(function () {
        customjs.init();
      }, 100);
    },
    btnShowWelFoodDetail() {
      this.showDiv = 'welFoodPop';
      setTimeout(function () {
        customjs.init();
      }, 100);
    },
    // 방문 희망일 변경
    modifyVisitHopeDate(index, orderId, receiptId) {
      if (this.visitHopeDate[index] == '') {
        this.msg = '방문희망일을 선택해주세요.';
        this.messagePop = true;
        this.messageType = '';
        return;
      }

      let param = {
        request: {
          orderId: orderId,
          receiptId: receiptId,
          userId: this.userInfo.userId,
          wishDate: moment(this.visitHopeDate[index]).format('yyyy-MM-DD'),
        },
        serviceType: 'app',
      };

      ApiService.service('PUT', '/service/auth/account/as/wishDate', param)
        .then(({ data }) => {
          if (data.isSucceed) {
            this.msg = '방문희망일이 변경 완료되었습니다.';
            this.messagePop = true;
            this.messageType = '';
          } else {
            this.msg = data.error;
            this.messagePop = true;
            this.messageType = '';
          }
        })
        .catch(({ response }) => {
          console.log('error : ' + response);
        });
    },
    applyCancel(orderId, receiptId) {
      let param = {
        request: {
          orderId: orderId,
          receiptId: receiptId,
          userId: this.userInfo.userId,
        },
        serviceType: 'app',
      };

      ApiService.service('DELETE', '/service/auth/as', param)
        .then(({ data }) => {
          // console.log(data);
          if (data.isSucceed) {
            this.selectServiceAuthAs();
            this.msg = 'AS 신청 접수가 취소되었습니다.';
            this.messagePop = true;
            this.messageType = '';
          } else {
            this.msg = data.error;
            this.messagePop = true;
            this.messageType = '';
          }
        })
        .catch(({ response }) => {
          console.log('error : ' + response);
          this.msg = SERVICE_COMM_ERROR;
          this.messagePop = true;
          this.messageType = '';
        });
    },
    changeProduct() {
      console.log('godsCrtnCd >> ' + this.product.godsCrtnCd);
      if (this.product.pb) {
        this.showBtnShowWelFoodDetail = true;
        this.selectServiceAsTypePb();
      } else {
        this.showBtnShowWelFoodDetail = false;
        this.selectServiceAsTypeNonpb();

        if (!this.product.supportAS) {
          let tel = /*this.product.registered ? this.product.serviceCenterTel :*/ '1670-0202';
          this.msg =
            '<p>죄송합니다. 선택하신 제품은 앱 상에서 <br>AS 접수 기능을 제공하지 않습니다. <br>웰릭스렌탈 고객센터로 문의해주세요.</p><p class="mt10">' +
            // this.product.vendorName +
            '대표번호 ' +
            tel +
            '</p>';
          setTimeout(() => {
            this.messagePop = true;
            this.messageType = 'asNoPb';
          }, 100);
        }
      }
    },
    selectServiceAsTypePb() {
      ApiService.service('GET', '/service/as/type/pb', '')
        .then(({ data }) => {
          console.log(data);
          this.serviceAsTypeList = data.result;
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    selectServiceAsTypeNonpb() {
      ApiService.service('GET', '/service/as/type/nonpb', '')
        .then(({ data }) => {
          // this.serviceAsTypeNonpbList = data.result;
          this.serviceAsTypeList = data.result;
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    addVisitHopeDefaultDate() {
      // this.addVisitHopeDate = this.calDay();

      // let today = new Date();
      // today.setDate(today.getDate() + 1);
      // this.addVisitHopeDate = moment(today).format('yyyy-MM-DD');

      ApiService.service('GET', '/common/businessDay/1')
        .then(({ data }) => {
          let dateStr1 = data.result.substr(0, 4);
          let dateStr2 = data.result.substr(4, 2);
          let dateStr3 = data.result.substr(6, 2);

          let dt = new Date(dateStr1 + '/' + dateStr2 + '/' + dateStr3 + ' 00:00:00');
          this.addVisitHopeDate = moment(dt).format('yyyy-MM-DD');
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    validate() {
      if (!this.product.supportAS) {
        let tel = /*this.product.registered && !isEmpty(this.product.serviceCenterTel) ? this.product.serviceCenterTel :*/ '1670-0202';
        this.msg =
          '<p>죄송합니다. 선택하신 제품은 앱 상에서 <br>AS 접수 기능을 제공하지 않습니다. <br>웰릭스렌탈 고객센터로 문의해주세요.</p><p class="mt10">' +
          //this.product.vendorName +
          '대표번호 ' +
          tel +
          '</p>';
        setTimeout(() => {
          this.messagePop = true;
          this.messageType = 'asNoPb';
        }, 100);

        return false;
      }

      if (isEmpty(this.product.orderId)) {
        this.msg = '상품을 선택해주세요.';
        setTimeout(() => {
          this.messagePop = true;
          this.messageType = '';
        }, 100);
        return false;
      }

      if (isEmpty(this.serviceAsType) || $('#serviceAsType').html().indexOf(this.serviceAsType) == -1) {
        this.msg = '접수유형을 선택해주세요.';
        setTimeout(() => {
          this.messagePop = true;
          this.messageType = '';
        }, 100);
        return false;
      }

      // TODO 주소저장기능 CRM 협의 필요
      /*
      if (isEmpty(this.addrCode) || isEmpty(this.addrPost) || isEmpty(this.addrRoad) || isEmpty(this.addrJibun) || isEmpty(this.addrRemark)) {
        this.msg = '주소를 입력해주세요.';
        setTimeout(() => {
          this.messagePop = true;
          this.messageType = '';
        }, 100);
        return false;
      }
      */

      const maxSize = 20 * 1024 * 1024;
      for (let file of this.files) {
        if (file.size > maxSize) {
          this.msg = '첨부파일 사이즈는 20MB 이내로 등록 가능합니다.';
          setTimeout(() => {
            this.messagePop = true;
            this.messageType = '';
          }, 100);
          return false;
        }
      }

      return true;
    },
    goAsComplete() {
      if (!this.validate()) {
        return;
      }

      let param = new Object();
      let request = new Object();

      request = {
        orderId: this.product.orderId,
        receiptTypeCode: this.serviceAsType,
        contents: this.asText,
        name: this.userInfo.userName,
        cellNum: this.userInfo.mobile,
        wishDate: moment(this.addVisitHopeDate).format('yyyy - MM - DD'),
        post: this.addrPost,
        address: this.addrRoad,
        addressDetail: this.addrRemark,
        godsCrtnCd: this.product.godsCrtnCd,
      };

      console.log('호출 직전 product.godsCrtnCd >> ' + request.godsCrtnCd);

      param.request = request;
      param.serviceType = 'app';

      let formData = new FormData();
      for (let file of this.files) {
        formData.append('files', file);
      }
      formData.append('param', JSON.stringify(param));

      let config = {
        headers: { 'Content-Type': 'multipart/form-data' },
      };
      this.$refs.progress.loadingStart();
      ApiService.service('POST', '/service/auth/as', formData, config)
        .then(({ data }) => {
          console.log(data);
          if (data.isSucceed) {
            const params = {
              af_order_id: this.product.orderId,
            };
            //const appsFlyerParams = JSON.stringify(params);
            window.appsFlyer('af_complete_as_application', params);

            this.msg = 'AS 신청 접수가 완료되었습니다.';
            this.messagePop = true;
            this.messageType = 'asComplete';
          } else {
            this.msg = data.error;
            this.messagePop = true;
            this.messageType = '';
          }
        })
        .catch(({ response }) => {
          console.log('error : ' + response);
        })
        .finally(() => {
          this.$refs.progress.loadingEnd();
        });
    },
    addrPopupOpen() {
      this.findAddr = true;
    },
    selectAddr(data) {
      this.addrCode = data.nnmb;
      this.addrPost = data.zip;
      this.addrRoad = data.nadr1;
      this.addrJibun = data.adr1;

      this.close();
    },
    photoZoom(fileMngId) {
      console.log(fileMngId);
      this.showDiv = 'asPhotosZoom';
      setTimeout(() => {
        this.$refs.progress.loadingStart();
        const files = [];
        ApiService.service('GET', 'common/downloadFile/' + fileMngId)
          .then(({ data }) => {
            console.log(data);
            if (data.isSucceed) {
              //this.photoList = [...data.result];
              data.result.forEach((item) => {
                const fileTpMCntn = item.exstFileLNm.split('.');
                if (typeof item.file === 'string') {
                  item = {
                    ...item,
                    file: item.file,
                    fileTpMCntn: item.fileTpMCntn ? item.fileTpMCntn.trim() : fileTpMCntn[fileTpMCntn.length - 1].trim(),
                    exstFileLNm: item.exstFileLNm.trim(),
                    keyname: item.keyname.trim(),
                  };
                  files.push(item);
                }
              });
            }
          })
          .catch(({ response }) => {
            console.log('error : ' + response);
          })
          .finally(() => {
            this.photoList = [...files];
            this.$refs.progress.loadingEnd();
          });
      }, 100);
    },
    close() {
      this.messagePop = false;
      this.findAddr = false;
    },
    asApplyPopClose() {
      this.messagePop = false;
      if (this.messageType != 'asNoPb') {
        this.showDiv = 'main';

        // AS 신청 완료후 재조회
        this.selectServiceAuthAs();
        this.selectlServiceAuthAsProducts();
        this.addVisitHopeDefaultDate();
      }
    },
    clickImgAdd() {
      // AsInfo, MyQnaInsertPop, MyReviewInsertPop
      document.getElementById('file').click();
      // if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
      //   //this.interval = setInterval(this.getFileAuth(), 200);
      //   this.fileAuth = '';
      //   window.getIosFileAuth();
      //   setTimeout(() => {
      //     this.fileAuth = window.getFileAuthCheckValue();
      //   }, 100);
      // } else {
      //   document.getElementById('file').click();
      // }
    },
    selectImg(event) {
      let file = event.target.files[0];
      this.files.push(file);
    },
    imgPreview(img) {
      return URL.createObjectURL(img);
    },
    deleteImg(index) {
      this.files.splice(index, 1);
    },
    goScroll() {
      document.getElementById('focusId').focus();
    },
    checkInput() {
      if (!isEmpty(this.product) && !isEmpty(this.serviceAsType) && this.addVisitHopeDate !== '') {
        this.regButtonShow = false;
      } else {
        this.regButtonShow = true;
      }
    },
    calDay() {
      let today = new Date();
      today =
        today.getDay() == 0 // 일요일
          ? new Date(today.setDate(today.getDate() + 1))
          : today.getDay() == 6 // 토요일
          ? new Date(today.setDate(today.getDate() + 2))
          : new Date();
      return today;
    },
  },
};
</script>
